var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FBFAF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 29.2578C19.6077 29.2578 19.2455 29.0968 18.9804 28.8051L10.8581 19.8781C10.4443 19.4233 10.3721 18.7584 10.6765 18.2231L13.1064 14.1124C13.354 13.6786 13.8142 13.4088 14.3074 13.4088H25.6901C26.1844 13.4088 26.6445 13.6786 26.8911 14.1124L29.321 18.2231C29.6264 18.7584 29.5532 19.4233 29.1394 19.8781L21.0171 28.8051C20.752 29.0968 20.3898 29.2578 19.9977 29.2578H19.9998Z",
    stroke: "#3D4837",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.cc6a4e8ce6bf44a654c8feb4d63f1e76.svg";
export { ForwardRef as ReactComponent };